import React from 'react';
import type { FC } from 'react';

import { SelectFormGroup, type SelectFormGroupProps } from '@admin/components/fields/select_form_group';
import { client } from '@admin/libraries/apollo';
import { useVehicleTypesQuery, type VehicleType } from '@admin/schema';

export type VehicleTypeSelectFormGroupProps = Omit<SelectFormGroupProps, 'children' | 'value' | 'onChange'> & {
  value?: string;
  onChange(value?: VehicleType['id']): void;
};

export const VehicleTypeSelectFormGroup: FC<VehicleTypeSelectFormGroupProps> = ({
  disabled,
  value,
  onChange,
  ...props
}) => {
  const { data, loading } = useVehicleTypesQuery({ client });
  const records = data?.vehicleTypes ?? [];

  return (
    <SelectFormGroup
      disabled={disabled || loading}
      {...props}
      value={value ?? ''}
      onChange={(event) => {
        onChange((event.target.value || undefined) as VehicleType['id'] | undefined);
      }}
    >
      <option value=""> - Type - </option>
      {records.map((record) => (
        <option value={record.id} key={record.id}>
          {record.name}
        </option>
      ))}
    </SelectFormGroup>
  );
};
